import { apiClient } from "./client";
import type {
  Extension,
  ExtensionCreateInput,
  ExtensionUpdateInput,
} from "@/types/entities";

export const extensionsApi = {
  getAllForTenant: async (tenantSlug: string): Promise<Extension[]> => {
    return apiClient.get<Extension[]>(`/tenants/${tenantSlug}/extensions`);
  },

  getById: async (tenantSlug: string, id: number): Promise<Extension> => {
    return apiClient.get<Extension>(`/tenants/${tenantSlug}/extensions/${id}`);
  },

  create: async (tenantSlug: string, data: ExtensionCreateInput): Promise<Extension> => {
    return apiClient.post<Extension>(`/tenants/${tenantSlug}/extensions`, data);
  },

  update: async (
    tenantSlug: string,
    id: number,
    data: ExtensionUpdateInput
  ): Promise<Extension> => {
    return apiClient.put<Extension>(`/tenants/${tenantSlug}/extensions/${id}`, data);
  },

  delete: async (tenantSlug: string, id: number): Promise<void> => {
    return apiClient.delete<void>(`/tenants/${tenantSlug}/extensions/${id}`);
  },

  resolveRuntime: async (tenantSlug: string, endpoint: string): Promise<Extension> => {
    const query = new URLSearchParams({ endpoint }).toString();
    return apiClient.get<Extension>(`/tenants/${tenantSlug}/extensions-runtime?${query}`);
  },
};
